import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class modelState extends baseState {
  @observable list = {};
  @action
  setList = data => this.list = data;
  getList = data => {
    return this.fetch({
      url: apiUrl.MODEL.LIST,
      method: 'get',
      setState: this.setList,
      data,
    });
  }

  addModel = data => {
    return this.fetch({
      url: apiUrl.MODEL.ADD_MODEL,
      data,
    });
  }

  updateModel = data => {
    return this.fetch({
      url: apiUrl.MODEL.UPDATE_MODEL,
      data,
    });
  }

  delModel = id => {
    return this.fetch({
      url: apiUrl.MODEL.DEL_MODEL + id,
      data: { id },
    });
  }

  getListAll = () => {
    return this.fetch({
      url: apiUrl.MODEL.LIST_ALL,
      method: 'get',
    });
  }
}
